import {
  CONTRACT_AUTHENTICATION_INITIALIZE,
  PARTICIPANT_SET_INFORMATION,
} from '@app/store/actionTypes';
import { ContractAuthenticationAction } from '@app/store/contract-authentication/actions';

import {
  fetchParticipantStatus,
  fetchParticipantStatusAfterLoginWithToken,
  ParticipantAction,
} from '../actions';

type DocumentIdState = string | null;

const initialState: DocumentIdState = null;

export default function reducer(
  state: DocumentIdState = initialState,
  action: ParticipantAction | ContractAuthenticationAction
) {
  switch (action.type) {
    case CONTRACT_AUTHENTICATION_INITIALIZE:
      return initialState;
    case fetchParticipantStatusAfterLoginWithToken.type:
    case fetchParticipantStatus.type:
    case PARTICIPANT_SET_INFORMATION:
      return action.payload.documentId || null;
    default:
      return state;
  }
}
